import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
              精选文章
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950">
              最新赛事分析与深度报道
            </h2>
          </div>
          <Link
            to="/category/football"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'h-64 lg:h-80' : 'h-48'}`}>
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-semibold rounded-full">
                    {article.category}
                  </span>
                </div>
                {article.featured && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-semibold rounded-full">
                      精选
                    </span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className={`font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 ${
                  idx === 0 ? 'text-xl' : 'text-base'
                }`}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}